import ShareMsgBase from './A_G.ShareMsgBase';

class MsgDailyRewardGet extends ShareMsgBase {
  /**
   * The message that is sent when you get something nice from the daily reward and you want to brag
   * @param {string} user1AvatarURL
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1AvatarURL, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(213, 64, user1AvatarURL, 0, 137, null);
    this.bg = this._addExtImage(0, 0, 'img/Share_Daily_Reward.png', 0, null, null);
  }
}

// create global references
G.MsgDailyRewardGet = MsgDailyRewardGet;
